import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import Actions from './actions';
var Types = Actions.Types;
var INITIAL_STATE = {
  latLon: {},
  zipcode: '',
  isLoading: false,
  isLoadingZipcode: false,
  isLoadingMap: true,
  results: [],
  additionalResults: [],
  mapResults: [],
  geoLocated: false,
  located: false,
  source: '',
  location: null,
  preferredLocation: null,
  waitlistId: null,
  changeLocationModal: false,
  changeNoLocationModal: true,
  // First load will switch it
  userModified: false
};

var locationReducer = function locationReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case Types.SET_LOADED:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoading: false
        });
      }

    case Types.SET_SOURCE:
      {
        var source = action.source;
        return _objectSpread(_objectSpread({}, state), {}, {
          source: source
        });
      }

    case Types.CHANGE_LAT_LON:
      {
        var position = action.position;
        return _objectSpread(_objectSpread({}, state), {}, {
          latLon: position
        });
      }

    case Types.CHANGE_ZIP_CODE:
      {
        var zipcode = action.zipcode;
        return _objectSpread(_objectSpread({}, state), {}, {
          zipcode: zipcode,
          tripPlannerActive: false,
          mapActive: undefined,
          isLoading: false,
          userModified: true
        });
      }

    case Types.SET_USER_MODIFIED_ACTION:
      {
        var userModified = action.userModified;
        return _objectSpread(_objectSpread({}, state), {}, {
          userModified: userModified,
          changeNoLocationModal: !userModified
        });
      }

    case Types.CHANGE_TRIP_PLANNER:
      {
        var tripPlannerAddress = action.tripPlannerAddress;
        return _objectSpread(_objectSpread({}, state), {}, {
          tripPlannerAddress: tripPlannerAddress,
          tripPlannerActive: true,
          mapActive: undefined,
          isLoading: false,
          locationFinderErr: false,
          pathInfo: {}
        });
      }

    case Types.SET_LOCATION:
      {
        var location = action.location;
        var storeId = (location === null || location === void 0 ? void 0 : location.StoreId) || (location === null || location === void 0 ? void 0 : location.storeId) || (location === null || location === void 0 ? void 0 : location.storeuid);

        if (location) {
          if (location.hasOwnProperty('EnableWaitlistCheckin')) {} else {
            location.EnableWaitlistCheckin = true; // TODO :: remove when DSTR-2562 in place
          }
        }

        return _objectSpread(_objectSpread({}, state), {}, {
          location: location,
          waitlistId: storeId,
          locationFinderErr: false,
          located: true,
          cookie: {
            OloCateringUniqueName: location.OloCateringUniqueName,
            StoreNumber: location.StoreNumber,
            OloUniqueName: location.OloUniqueName,
            State: location.State,
            PostalCode: location.PostalCode
          }
        });
      }

    case Types.SET_LOCATED:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          located: true
        });
      }

    case Types.REQUEST_GEO_IP:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoading: true
        });
      }

    case Types.REQUEST_LOCATIONS:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoading: true,
          isLoadingMap: true
        });
      }

    case Types.REQUEST_ZIPCODES:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoadingZipcode: true,
          err: {},
          isError: false
        });
      }

    case Types.RECEIVE_LOCATIONS:
      {
        var results = action.results,
            mapResults = action.mapResults,
            userLatitude = action.userLatitude,
            userLongitude = action.userLongitude;
        return _objectSpread(_objectSpread({}, state), {}, {
          mapResults: mapResults,
          results: results,
          additionalResults: results,
          //.filter((_, i) => i !== 0),
          isLoading: false,
          isLoadingMap: false,
          isLoadingZipcode: false,
          err: {},
          isError: false,
          locationFinderErr: false,
          userLatitude: userLatitude,
          userLongitude: userLongitude // userModified: true,

        });
      }

    case Types.RECEIVE_ADDITIONAL_LOCATIONS:
      {
        var _results = action.results;
        return _objectSpread(_objectSpread({}, state), {}, {
          results: _results,
          additionalResults: _results,
          isLoading: false,
          isLoadingMap: false,
          isLoadingZipcode: false,
          err: {},
          isError: false,
          locationFinderErr: false
        });
      }

    case Types.CHANGE_PREFERRED_LOCATION:
      {
        var preferredLocation = action.preferredLocation;
        return _objectSpread(_objectSpread({}, state), {}, {
          preferredLocation: preferredLocation
        });
      }

    case Types.RECEIVE_LAT_LON:
      {
        var _position = action.position,
            geoLocated = action.geoLocated;
        return _objectSpread(_objectSpread({}, state), {}, {
          latLon: _position,
          geoLocated: geoLocated // isLoading: true // TODO :: RE-ENABLED

        });
      }

    case Types.RECEIVE_ERROR:
      {
        var err = action.err;
        return _objectSpread(_objectSpread({}, state), {}, {
          mapResults: {
            address1: 'Location error'
          },
          isLoading: false,
          isLoadingMap: false,
          isLoadingZipcode: false,
          isError: true,
          err: err
        });
      }

    case Types.TOGGLE_CHANGE_MODAL:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          changeLocationModal: !state.changeLocationModal,
          userModified: true
        });
      }

    case Types.TOGGLE_CHANGE_NO_LOCATION_MODAL:
      {
        console.log('Called no location modal: ', state.changeNoLocationModal);
        return _objectSpread(_objectSpread({}, state), {}, {
          changeNoLocationModal: state.changeNoLocationModal // userModified: true // continue to show nolocation modal on page refresh until a store is selected

        });
      }

    case Types.REQUEST_FROM_URL:
      {
        var address = action.address;
        return _objectSpread(_objectSpread({}, state), {}, {
          addressparam: address
        });
      }

    case Types.REQUEST_FROM_URL_VENDORID:
      {
        var vendoridobj = action.vendoridobj;
        return _objectSpread(_objectSpread({}, state), {}, {
          vendoridobj: vendoridobj
        });
      }

    case Types.REQUEST_LOCATION_LAT_LON:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          zipcode: ""
        });
      }

    case Types.SET_MAP_ACTIVE:
      {
        var mapActive = action.mapActive;
        return _objectSpread(_objectSpread({}, state), {}, {
          mapActive: mapActive
        });
      }

    case Types.LOCATION_FINDER_ERR:
      {
        var _err = action.err;
        return _objectSpread(_objectSpread({}, state), {}, {
          locationFinderErr: true,
          isLoading: false,
          isLoadingZipcode: false,
          isError: true,
          results: [],
          err: _err,
          additionalResults: []
        });
      }

    case Types.SET_TRIP_PLANNER_LOC:
      {
        var tripPlannerLoc = action.tripPlannerLoc;
        return _objectSpread(_objectSpread({}, state), {}, {
          tripPlannerLoc: tripPlannerLoc
        });
      }

    case Types.SAVE_PATH_INFO:
      {
        var pathInfo = action.pathInfo;
        return _objectSpread(_objectSpread({}, state), {}, {
          pathInfo: pathInfo
        });
      }

    case Types.FLIP_MODIFIED:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          userModified: true
        });
      }

    default:
      {
        return state;
      }
  }
};

export default locationReducer;